import type { RootState } from '@/store';
import type { IAuthState, IUser } from '@/store/types';
import type { IClient, ILxProfile } from '@/api/types';

import { UserType } from '@/store/enums';
import { NO_TIMEZONE_ERROR } from '@/constants/error';

export const selectContractColors = (state: RootState): IAuthState['contractColors'] => state.auth.contractColors;
export const selectIsError = (state: RootState): IAuthState['isError'] => state.auth.isError;
export const selectIsSuccess = (state: RootState): IAuthState['isSuccess'] => state.auth.isSuccess;
export const selectIsFetching = (state: RootState): IAuthState['isFetching'] => state.auth.isFetching;
export const selectAgentContractClients = (state: RootState): ILxProfile['agentContractClients'] | undefined =>
  state.auth.user?.agentContractClients;
export const selectAgentContractJobs = (state: RootState): ILxProfile['agentContractJobs'] | undefined =>
  state.auth.user?.agentContractJobs;
export const selectAgentContractSchedules = (state: RootState): ILxProfile['agentContractSchedules'] | undefined =>
  state.auth.user?.agentContractSchedules;
export const selectAgentContracts = (state: RootState): ILxProfile['agentContracts'] | undefined =>
  state.auth.user?.agentContracts;
export const selectDisplayLabels = (state: RootState): IAuthState['displayLabels'] => state.auth.displayLabels;
export const selectUserType = (state: RootState): UserType => state.auth.user?.userTypeId ?? UserType.unauthorized;
export const selectUser = (state: RootState): IAuthState['user'] => state.auth.user;
export const selectUserId = (state: RootState): IUser['id'] | undefined => state.auth.user?.id;
export const selectApplication = (state: RootState): IAuthState['application'] => state.auth.application;
export const selectAuthStatus = (state: RootState): IAuthState['authStatus'] => state.auth.authStatus;
export const selectAuthMenuType = (state: RootState): IAuthState['menuType'] => state.auth.menuType;
export const selectCurrentClient = (state: RootState): IClient | null | undefined => state.auth.user?.currentClient;
export const selectCurrentClientId = (state: RootState): number | undefined => state.auth.user?.currentClient?.clientId;
export const selectUserTimezone = (state: RootState): string => {
  if (!state.auth.user?.timeZoneName) {
    throw new Error(NO_TIMEZONE_ERROR);
  }
  return state.auth.user.timeZoneName;
};

export const hasActiveGigs = (state: RootState): boolean => state.auth.user?.hasActiveGigs ?? false;
